import './scss/estilos.scss';
import buzon from './buzon';
import editorFoto from './editorFoto';
import camara from './camara';
import fondo from './fondo';

buzon();
editorFoto();
camara();
fondo();
